/** Canonical committee types — stored as `code` in csadmin_committees.committee_type */
export const COMMITTEE_TYPES = [
  { code: 'AUDIT', label: 'Audit Committee' },
  { code: 'RISK', label: 'Risk Management Committee' },
  { code: 'NOMINATION', label: 'Nomination Committee' },
  { code: 'REMUNERATION', label: 'Remuneration Committee' },
  { code: 'GOVERNANCE', label: 'Governance Committee' },
  { code: 'EXECUTIVE', label: 'Executive Committee' },
  { code: 'INVESTMENT', label: 'Investment Committee' },
  { code: 'COMPLIANCE', label: 'Compliance Committee' },
  { code: 'OTHER', label: 'Other' },
];

const CODE_SET = new Set(COMMITTEE_TYPES.map((t) => t.code));

/** Map legacy DB / mock values to canonical code */
export function normalizeCommitteeTypeCode(raw) {
  if (raw === null || raw === undefined || raw === '') return '';
  const s = String(raw).trim();
  const upper = s.toUpperCase();
  if (CODE_SET.has(upper)) return upper;

  const byLabel = COMMITTEE_TYPES.find((t) => t.label.toLowerCase() === s.toLowerCase());
  if (byLabel) return byLabel.code;

  const lower = s.toLowerCase();
  if (lower === 'audit' || lower.startsWith('audit')) return 'AUDIT';
  if (lower.includes('risk')) return 'RISK';
  if (lower.includes('nomination')) return 'NOMINATION';
  if (lower.includes('remuneration') || lower.includes('compensation')) return 'REMUNERATION';
  if (lower.includes('governance')) return 'GOVERNANCE';
  if (lower.includes('executive')) return 'EXECUTIVE';
  if (lower.includes('investment')) return 'INVESTMENT';
  if (lower.includes('compliance')) return 'COMPLIANCE';
  if (lower === 'other') return 'OTHER';

  return upper;
}

export function committeeTypeLabel(raw) {
  const code = normalizeCommitteeTypeCode(raw);
  const match = COMMITTEE_TYPES.find((t) => t.code === code);
  return match?.label || (raw ? String(raw) : '');
}

export function committeeTypesMatch(stored, filterCode) {
  if (!filterCode) return true;
  return normalizeCommitteeTypeCode(stored) === normalizeCommitteeTypeCode(filterCode);
}

export const COMMITTEE_TYPE_FILTER_OPTIONS = COMMITTEE_TYPES.map((t) => ({
  value: t.code,
  label: t.label.replace(/ Committee$/, ''),
}));
